import { useNavigate } from '@solidjs/router'
import { Component, onMount } from 'solid-js'

const Overview: Component = () => {
    let nav = useNavigate()

    onMount(() => {
        nav('profile')
    })
    return <div>overview</div>
}

export default Overview
